import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Dropdown, Form } from "react-bootstrap";
import { PulseLoader } from "react-spinners";
import MemberDropdown from "../member-dropdown/member-dropdown";
import MemberDropdownNew from "../member-dropdown-new/member-dropdown-new";
import TypesDropdown from "./types-dropdown";
import FilterDefaultDropdown from "./Fitler-Default-Dropdown";
import ToggleAll from "../Toggle-All-Row/Toggle-All-Row";
import { GetAllUsers } from "../../services/api/user-api";
import { selectUserID } from "../../redux/user/user-selector";
import "./filter-panel.scss";

//POTENTIAL WAY TO MAKE MORE EFFICIENT- MAKE FILTERPANEL A DIV ON CLICK SO THE PANEL HTML/CSS IS MORE REUSABLE
const FiltersPanel = ({
  header,
  type,
  close,
  selected,
  save,
  clear,
  updateSelected,
  change,
  filterIcon,
  adminPayload,
  filterPayload = []
}) => {
  const [payload, setPayload] = useState([]);
  const [showFilter, setShowFilter] = useState(false); //Will always be false when this is called, changed internally in useEffects
  //SEARCHBAR STRING
  const [searchFilter, setSearchFilter] = useState([]);
  //RENDERED ROWS
  const [rowFilter, setRowFilter] = useState([]);
  //CHECKED ROWS
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsCounter, setSelectedRowsCounter] = useState(0);
  //CHANGING VARIABLES AND CLASSNAMES DEPENDING ON TYPE FOR LOGIC AND STYLING
  const [nameClass, setNameClass] = useState("");
  const [title, setTitle] = useState(header);
  const [idParam, setIDParam] = useState("");
  const [nameParam, setNameParam] = useState("");
  //LOADING VARIABLE
  const [isLoading, setIsLoading] =  useState(false);
  //ALL XXX
  const [allTitle, setAllTitle] = useState("");
  //SPECIFIC TO MEMBERS COLUMN
  //MEMBERS RADIO BUTTONS
  const [assignedByOrTo, setAssignedByOrTo] = useState(true);
  const [assignedBy, setAssignedBy] = useState(true);
  const [assignedTo, setAssignedTo] = useState(true);
  //WHEN 0- UNCHECKED 1- ALL 2- ASSIGNEDBY 3- ASSIGNED TO
  const [radioButtonTracker, setRadioButtonTracker] = useState(1);
  //SPECIFIC TO TYPES COLUMN
  const [dropdownTrigger, setDropdownTrigger] = useState(true);

  const userID = useSelector(selectUserID);

  //HANDLES MOUSE CLICKS OUTSIDE OF ELEMENT
  const ref = useRef();

  const handleClick = (e) => {
    if (ref.current.contains(e.target)) {
      // inside click
      return;
    }
    closeFilter();
  };

  useEffect(() => {
    // add when mounted
    document.addEventListener("click", handleClick); // return function to be called when unmounted
    return () => {
      document.removeEventListener("click", handleClick);
    };

  }, []);

  //SEARCH BAR FUNCTIONALITY
  useEffect(() => {
    let newFilter = [];
    if (searchFilter != "") {
      newFilter = payload.filter((row) =>
        row[nameParam].toLowerCase().includes(searchFilter.toLowerCase())
      );
    } else {
      newFilter = payload; //resets rows
    }
    setRowFilter(newFilter);
  }, [searchFilter]);

  useEffect(() => {
    if (searchFilter === "") {
      setRowFilter(payload);
    }
    setPayload(payload);
  }, [rowFilter]);

  //UPDATE ROWS COUNTER WHENEVER THE SELECTEDROWS ARRAY CHANGES
  useEffect(() => {
    setSelectedRowsCounter(selectedRows.length);
  }, [selectedRows, selectedRowsCounter]);

  //TOGGLE BETWEEN RADIO BUTTONS
  useEffect(() => {
    if (radioButtonTracker === 1) {
      setAssignedBy(false);
      setAssignedTo(false);
      setAssignedByOrTo(true)
    } else if (radioButtonTracker === 2) {
      setAssignedTo(false);
      setAssignedBy(true);
      setAssignedByOrTo(false)
    } else if (radioButtonTracker === 3) {
      setAssignedBy(false);
      setAssignedTo(true);
      setAssignedByOrTo(false)
    }
  }, [radioButtonTracker]);

  useEffect(() => {
    setRowFilter(payload);
  }, [payload]);

  const getPayload = async () => {
    change();
    let newUsers = [];
    if (!showFilter) {
      setShowFilter(true);

      //OPENING FILTER
      switch (type) {
        case "Members":
          setIsLoading(true);
          setIDParam("userID");
          setNameParam("userNameFull");
          setNameClass("-members");
          setSelectedRows(selected);
          setAllTitle("Members");
          GetAllUsers({
            filters: filterPayload,
            sortDesc: false,
            sortBy: "name",
            pageSize: 1000,
            pageNumber: 1,
          }).then((users) => {
            newUsers = editMemberPayload(users.users); //current user index 0
            setPayload(newUsers);
            setIsLoading(false);
          });
          break;
        case "Types":
          setPayload([]); //MAKE IT EMPTY FOR TYPES
          setTitle("Type");
          setIDParam(""); //NO IDPARAM FOR TYPES or PAYLOAD
          setNameParam("");
          setAllTitle("Types");
          setSelectedRows(selected);
          if (dropdownTrigger === false) {
            setNameClass("-types-no-drop");
          } else {
            setNameClass("-types");
          }
          break;
        //CODE FOR ADMIN PAGE
        //USERS TAB
        case "Users":
          setIsLoading(true);
          setIDParam("userID");
          setNameParam("userNameFull");
          setAllTitle("Users");
          setSelectedRows(selected);
          setPayload(editMemberPayload(adminPayload));
          setIsLoading(false);
          break;
        case "UsersNew":
          setIsLoading(true);
          setIDParam("Id");
          setNameParam("Name");
          setAllTitle("Users");
          setSelectedRows(selected);
          setPayload(editMemberPayload(adminPayload));
          setIsLoading(false);
          break;
        case "Departments":
          setIsLoading(true);
          setIDParam("companyID");
          setNameParam("name");
          setAllTitle("Departments");
          setSelectedRows(selected);
          setPayload(adminPayload); //FORMATTED CORRECTLY
          setIsLoading(false);
          break;
        case "DepartmentsNew":
        case "DepartmentDepartmentsNew":
            setIsLoading(true);
            setIDParam("Id");
            setNameParam("Name");
            setAllTitle("Departments");
            setSelectedRows(selected);
            setPayload(adminPayload); //FORMATTED CORRECTLY
            setIsLoading(false);
            break;
        case "Roles":
        case "RolesNew":
          setIsLoading(true);
          setIDParam("roleID");
          setNameParam("roleName");
          setAllTitle("Roles");
          setSelectedRows(selected);
          setPayload(adminPayload); //FORMATTED CORRECTLY
          setIsLoading(false);
          break;
        //GROUPS TAB
        case "Groups":
          setIsLoading(true);
          setIDParam("groupID");
          setNameParam("name");
          setAllTitle("Groups");
          setSelectedRows(selected);
          setPayload(adminPayload);
          setIsLoading(false);
          break;
        case "GroupsNew":
          setIsLoading(true);
          setIDParam("Id");
          setNameParam("Name");
          setAllTitle("Groups");
          setSelectedRows(selected);
          setPayload(adminPayload);
          setIsLoading(false);
          break;
        case "Creators":
        case "Creators New": //same as Users
          setIsLoading(true);
          setIDParam("userID");
          setNameParam("userNameFull");
          setAllTitle("Creators");
          setSelectedRows(selected);
          setPayload(editMemberPayload(adminPayload));
          setIsLoading(false);
          break;
        case "Group Members": //same as Users
        case "Group Members New":
          setIsLoading(true);
          setIDParam("userID");
          setAllTitle("Group Members");
          setNameParam("userNameFull");
          setSelectedRows(selected);
          setPayload(editMemberPayload(adminPayload));
          setIsLoading(false);
          break;
        //ROLES TAB
        case "RoleRoles":
          setIsLoading(true);
          setIDParam("roleID");
          setNameParam("roleName");
          setAllTitle("Roles");
          setSelectedRows(selected);
          setPayload(adminPayload);
          setIsLoading(false);
          break;
        case "RoleRolesNew":
          setIsLoading(true);
          setIDParam("Id");
          setNameParam("Name");
          setAllTitle("Roles");
          setSelectedRows(selected);
          setPayload(adminPayload); //FORMATTED CORRECTLY
          setIsLoading(false);
          break;
        case "RoleDepartments":
          setIsLoading(true);
          setIDParam("companyID");
          setNameParam("name");
          setAllTitle("Departments");
          setSelectedRows(selected);
          setPayload(adminPayload); //FORMATTED CORRECTLY
          setIsLoading(false);
          break;
        case "RoleDepartmentsNew":
            setIsLoading(true);
            setIDParam("Id");
            setNameParam("Name");
            setAllTitle("Departments");
            setSelectedRows(selected);
            setPayload(adminPayload); //FORMATTED CORRECTLY
            setIsLoading(false);
            break;
        //deprecate department
        case "DepartmentDepartments":
          setIsLoading(true);
          setIDParam("companyID");
          setNameParam("name");
          setAllTitle("Departments");
          setSelectedRows(selected);
          setPayload(adminPayload); //FORMATTED CORRECTLY
          setIsLoading(false);
          break;
        //LOG ACTIVITY TABS
        case "LogActivityEventType":
          setIsLoading(true);
          setIDParam("actions");
          setNameParam("actions");
          setAllTitle("Event Type")
          setSelectedRows(selected);
          setPayload(adminPayload); //FORMATTED CORRECTLY
          adminPayload.length > 0 && setIsLoading(false);
          break;
        case "LogActivityCreatedBy":
          setIsLoading(true);
          setIDParam("userID");
          setNameParam("userName");
          setAllTitle("Creators");
          setSelectedRows(selected);
          setPayload(editMemberPayload(adminPayload));
          adminPayload.length > 0 && setIsLoading(false);
          break;
        //TEMPLATES PAGE
        case "projectTemplateNames":
            setIsLoading(true);
            setIDParam("id");
            setNameParam("projectType");
            setAllTitle("Project Templates");
            setSelectedRows(selected);
            setPayload(adminPayload);
            adminPayload.length > 0 && setIsLoading(false);
            break;
          case "projectTemplateNamesNew":
            setIsLoading(true);
            setIDParam("Id");
            setNameParam("ProjectType");
            setAllTitle("Project Templates");
            setSelectedRows(selected);
            setPayload(adminPayload);
            adminPayload.length > 0 && setIsLoading(false);
            break;
          //TEMPLATE TASK PAGE
          case "ProjectTemplateTaskName":
            setIsLoading(true);
            setIDParam('assignID');
            setNameParam('taskName');
            setAllTitle('Template Task Names');
            setSelectedRows(selected);
            setPayload(adminPayload);
            adminPayload.length > 0 && setIsLoading(false);
            break;
          case "ProjectTemplateTaskNameNew":
              setIsLoading(true);
              setIDParam('Id');
              setNameParam('Name');
              setAllTitle('Template Task Names');
              setSelectedRows(selected);
              setPayload(adminPayload);
              adminPayload.length > 0 && setIsLoading(false);
              break;
          case "ProjectTemplateTaskType":
            setIsLoading(true);
            setIDParam('id');
            setNameParam('name');
            setAllTitle('Task Types');
            setSelectedRows(selected);
            setPayload(adminPayload);
            adminPayload.length > 0 && setIsLoading(false);
            break;
          case "ProjectTemplateTaskTypeNew":
            setIsLoading(true);
            setIDParam('Id');
            setNameParam('Name');
            setAllTitle('Task Types');
            setSelectedRows(selected);
            setPayload(adminPayload);
            adminPayload.length > 0 && setIsLoading(false);
            break;
        case "ProjectMembers":
          setIsLoading(true);
          setIDParam("userID");
          setNameParam("userNameFull");
          setNameClass("-members");
          setSelectedRows(selected);
          setAllTitle("Members");
          GetAllUsers({
            filters: filterPayload,
            sortDesc: false,
            sortBy: "name",
            pageSize: 1000,
            pageNumber: 1,
          }).then((users) => {
            newUsers = editMemberPayload(users.users); //current user index 0
            setPayload(newUsers);
            setIsLoading(false);
          });
          break;
         case "ProjectMembersNew":
            setIsLoading(true);
            setIDParam("userID");
            setNameParam("userNameFull");
            setNameClass("-members");
            setSelectedRows(selected);
            setAllTitle("Members");
            GetAllUsers({
              filters: filterPayload,
              sortDesc: false,
              sortBy: "name",
              pageSize: 1000,
              pageNumber: 1,
            }).then((users) => {
              newUsers = editMemberPayload(users.users); //current user index 0
              setPayload(newUsers);
              setIsLoading(false);
            });
            break;
        case "ProjectTags":
          setIsLoading(true);
          setIDParam('id');
          setNameParam('name');
          setAllTitle('Tags');
          setSelectedRows(selected);
          setPayload(adminPayload);
          adminPayload.length > 0 && setIsLoading(false);
          break;
        case "ProjectTagsNew":
            setIsLoading(true);
            setIDParam('id');
            setNameParam('name');
            setAllTitle('Tags');
            setSelectedRows(selected);
            setPayload(adminPayload);
            adminPayload.length > 0 && setIsLoading(false);
            break;
        default:
          setIsLoading(true);
          setIDParam('FieldValue');
          setNameParam('FieldValue');
          setSelectedRows(selected);
          setPayload(adminPayload);
          setIsLoading(false);
          break;
      }
    } else {
      setShowFilter(false);
      close();
    }
  };

  //FOR MEMBERS AND USERS, FIND CURRENTUSER ID AND PUT THAT IN FRONT OF ARRAY
  const editMemberPayload = (users) => {
    if (type == "UsersNew") {
      users.sort(function (x, y) {
        return x.Id === userID ? -1 : y.Id === userID ? 1 : 0;
      });
      if (users[0].Name[users[0].Name.length - 1] !== ")") {
        users[0].Name += "  (Me)";
      }
      return users;
    }
    else
    {
      users.sort(function (x, y) {
        return x.userID === userID ? -1 : y.userID === userID ? 1 : 0;
      });
      if (users[0].userNameFull[users[0].userNameFull.length - 1] !== ")") {
        users[0].userNameFull += "  (Me)";
      }
      return users;
    }
  };


  //CALLED WHEN USER SELECTS A ROW
  //ADDS CHECKED ROW TO SELECTEDROWS VARIABLE AND REMOVES UNCHECKED ROW
  const toggleRow = (chosen, checked) => {
    let chosenRow = [];
    if (checked) {
      //HANDLES ARRAYS FOR TYPES AND FOR ADDING FILTER
      chosenRow = selectedRows;
      Array.isArray(chosen)
        ? chosenRow.push(...chosen)
        : chosenRow.push(chosen);
      //NEED TO REMOVE ALL DUPLICATES
      let chosenSet = new Set(chosenRow)
      chosenRow = [...chosenSet]

      } else {
      //WHEN CHOSEN IS EMPTY
      if (chosen.length === 0) {
        chosenRow = [];
      } else {
        const index = selectedRows.indexOf(chosen);
        chosenRow = selectedRows;
        chosenRow.splice(index, 1);
      }
    }
    setSelectedRows(chosenRow);
    setSelectedRowsCounter(selectedRows.length); //for counter
  };

  //ONSUBMIT
  const saveFilter = () => {
    updateSelected(selectedRows, type);
    let ids = [];
    let typesIds = [
      {
        id: 0,
        typeName: "Standard Task",
      },
      {
        id: 1,
        typeName: "Word",
      },
      {
        id: 2,
        typeName: "Excel",
      },
      {
        id: 3,
        typeName: "PowerPoint",
      },
    ];

    //MAKING ARRAY OF IDS TO PUT IN COLUMNS
    if (type === "Types") {
      //looping through Types and assigning ids
      selectedRows.map((row) => {
        for (let i = 0; i < typesIds.length; i++) {
          if (row === typesIds[i].typeName) {
            ids.push(typesIds[i].id);
          }
        }
      });
      ids.sort();
    } else {
      ids = selectedRows.map((row) => row[idParam]);
    }
    //THESE ARE ARRAYS BECAUSE MEMBERS HAS CHANCE OF MAKING 2 COLUMNS
    let colName = [];
    let idFieldName = [];
    //NEW COLUMN(S) FOR FILTERS
    let newFilter = [];
    //SETTING NAMES OF FILTER FIELDS
    switch (type) {
      case "Members":
        if (assignedBy) {
          colName.push("createdBy");
          idFieldName.push("creatorIDs");
          break;
        }
        if (assignedTo) {
          //DISABLING FOR NOW AND REPLACING WITH SAME LOGIC AS "ALL"
          //colName.push("assignTo");
          //idFieldName.push("assigneeIDs");
          colName.push("createdByOrAssignTo");
          idFieldName.push("creatorOrAssigneeIDs");
          break;
        }
        if (setAssignedByOrTo){
          colName.push("createdByOrAssignTo");
          idFieldName.push("creatorOrAssigneeIDs");
          break;
        }
        break;
      case "Types":
        colName.push("documentType");
        idFieldName.push("documentTypeIDs");
        break;
      //FOR ADMIN PAGE
      case "Users":
        colName.push("name");
        idFieldName.push("userIDs");
        break;
      case "UsersNew":
        colName.push("name");
        idFieldName.push("value");
        break;
      case "Departments":
        colName.push("department");
        idFieldName.push("departmentIDs");
        break;
      case "DepartmentsNew":
          colName.push("department");
          idFieldName.push("value");
          break;
      case "Roles":
        colName.push("role");
        idFieldName.push("roleIDs");
        break;
      case "RolesNew":
          colName.push("role");
          idFieldName.push("value");
          break;
      case "Groups":
        colName.push("name");
        idFieldName.push("groupIDs");
        break;
      case "Creators":
        colName.push("createdBy");
        idFieldName.push("userIDs");
        break;
      case "Creators New":
        colName.push("CreatedBy");
        idFieldName.push("value");
        break;
      case "Group Members":
        colName.push("member");
        idFieldName.push("memberIDs");
        break;
      case "Group Members New":
        colName.push("Member");
        idFieldName.push("value");
        break;
      case "RoleRoles":
        colName.push("name");
        idFieldName.push("roleIDs");
        break;
      case "RoleRolesNew":
        colName.push("name");
        idFieldName.push("roleIDs");
        break;
      case "RoleDepartments":
      case "RoleDepartmentsNew":
        colName.push("department");
        idFieldName.push("departmentIDs");
        break;
      //deprecate department
      case "DepartmentDepartments":
        colName.push('name');
        idFieldName.push('departmentIDs');
        break;
      case "ProjectProjects":
        colName.push('name');
        idFieldName.push('projectIDs');
        break;
      case "ProjectMembers":
        colName.push('member');
        idFieldName.push('memberIDs');
        break;
      case "ProjectTags":
        colName.push('tags');
        idFieldName.push("tags");
        break;
      case "LogActivityEventType":
        colName.push("eventType");
        idFieldName.push("actions");
        break;
      case "LogActivityCreatedBy":
        colName.push("createdBy");
        idFieldName.push("userIDs");
        break;
      case "projectTemplateNames":
        colName.push("name");
        idFieldName.push("projectTemplateIDs");
        break;
      case "DepartmentDepartmentsNew":
      case "GroupsNew":
      case "projectTemplateNamesNew":
      case "ProjectTemplateTaskNameNew":
        colName.push("Name");
        idFieldName.push("value");
        break;
      case "ProjectTemplateTaskTypeNew":
        colName.push("WorkItemType");
        idFieldName.push("value");
        break;
      case "ProjectTemplateTaskName":
        colName.push('name');
        idFieldName.push('workItemIDs');
        break;
      case "ProjectTemplateTaskType":
        colName.push('type');
        idFieldName.push('workItemTypes');
        break;
      default:
        colName.push(type);
        idFieldName.push('fieldValue');
    }

    //ADDING COLUMNS TO FILTERS
    for (let i = 0; i < colName.length; i++) {
      let fieldName = idFieldName[i];
      if (colName[i] === "taskName") {
        //temporary solution
        newFilter.push({
          column: colName[i],
          [fieldName]: ids,
          workitemIDs: ids,
        });
      } else {
        newFilter.push({
          column: colName[i],
          [fieldName]: ids,
        });
      }
    }
    if (ids.length < 1) {
      setSelectedRowsCounter(0);
      setSelectedRows([]);
      setRowFilter([]);
      setPayload([]);
      clear(type); //if you apply 0 filters, it will get rid of all filters
    } else {
      save(newFilter, idFieldName);
    }
    closeFilter();
  };

  //ON CANCEL
  const clearFilter = (e) => {
    updateSelected([], type);
    setSelectedRowsCounter(0);
    setSelectedRows([]);
    setRowFilter([]);
    setPayload([]);
    clear(type);
    closeFilter();
  };

  //CLOSES FILTER
  const closeFilter = () => {
    setShowFilter(false);
    setSearchFilter("");
    setSelectedRows(selected);
    close();
  };

  //////////////////////////
  //SPECIFIC TO TYPES COLUMN
  //////////////////////////

  //FUNCTION TO REMOVE ALL MSOFFICE FILTERS
  const removeMSOffice = () => {
    let msOffice = ["PowerPoint", "Word", "Excel"];
    let chosenRow = selectedRows.filter((row) => !msOffice.includes(row));
    setSelectedRows(chosenRow);
  };

  //CHANGE STYLING WHEN MS OFFICE DROPDOWN IS CLICKED
  const typesDropdown = (dropped) => {
    setDropdownTrigger(dropped);
  };

  //TOGGLES DROPDOWN STYLING FOR TYPES FILTER PANEL
  useEffect(() => {
    if (type === "Types") {
      if (dropdownTrigger === false) {
        setNameClass("-types-no-drop");
      } else {
        setNameClass("-types");
      }
    }
  }, [dropdownTrigger]);

  return (
    <Dropdown show={showFilter} ref={ref} style={{ cursor: "default" }}>
      <Dropdown.Toggle
        style={{cursor: 'pointer'}}
        as={"img"}
        src={filterIcon}
        alt="filter-arrow"
        className="filter-panel-toggle"
        onClick={() => getPayload()}
      />
      {
        //MENU IS A BIT HIGHER THAN I THOUGHT, CAN'T SEEM TO MOVE DOWN
      }
      <Dropdown.Menu>
        { isLoading ? (
          <div
            style={{
              width: "478px",
              height: "441px",
              textAlign: "center",
              paddingTop: "220px",
            }}
          >
            <PulseLoader></PulseLoader>
          </div>
        ) : (
          <div className={`filter-panel-dropdown${nameClass}`}>
            <div className={`filter-panel-dropdown-top-container${nameClass}`}>
              <Dropdown.Header
                className={`filter-panel-dropdown-title${nameClass}`}
              >
                Filter {title}
              </Dropdown.Header>
              { type === "Members" &&
                <div className="filter-panel-dropdown-members-radio">
                  <div style={{ "margin-right": "20px", "font-weight": "bold" }} >
                    <label>
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={radioButtonTracker === 1}
                        onChange={() => setRadioButtonTracker(1)}
                      />
                      All
                    </label>
                  </div>
                  <div style={{ "margin-right": "20px" }}>
                    <label>
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={radioButtonTracker === 2}
                        onChange={() => setRadioButtonTracker(2)}
                      />
                      Assigned By
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                        className={"filter-panel-dropdown-members-radio-button"}
                        type="radio"
                        checked={radioButtonTracker === 3}
                        onChange={() => setRadioButtonTracker(3)}
                      />
                      Assigned To
                    </label>
                  </div>
                </div>
              }
              { type != "Types" &&
                <>
                  <Form.Control
                    className={`filter-panel-dropdown-searchbar${nameClass}`}
                    as="textarea"
                    rows="1"
                    value={searchFilter}
                    onChange={(e) => setSearchFilter(e.target.value)}
                  />
                </>
              }
            </div>
            <Form>
              { //DROPDOWN DEPENDS ON TYPE
                type != "Types" &&
                <div className={`filter-panel-dropdown-selected-counter${nameClass}`} >
                  {selectedRowsCounter} selected
                </div>
              }
              {
                //SINCE TYPES IS UNIQUE WE KEEP IT
                type === "Types" ? (
                  <>
                    <TypesDropdown
                      toggleRow={toggleRow}
                      selectedRows={selectedRows}
                      removeMSOffice={removeMSOffice}
                      typesDropdown={typesDropdown}
                    />
                  </>
                ) : type === "Members" ||
                  type === "Users" ||
                  type === "UsersNew" ||
                  type === "Creators" ||
                  type === "Group Members" ||
                  type === "ProjectMembers" ? (
                  <>
                    <div className={`filter-panel-dropdown${nameClass}-container`} >
                      <Dropdown.Divider style={{ width: "478px" }} />
                      {
                        <ToggleAll
                          toggleAllRows={toggleRow}
                          payload={payload}
                          type={allTitle}
                          rows={selectedRows}
                          rowFilter={rowFilter}
                        />
                      }
                      <Dropdown.Divider style={{ width: "478px" }} />
                      { rowFilter &&
                        rowFilter.map((member, index) => {
                          const isUser = index === 0 && (type == "UsersNew" ? member.Id === userID : member.userID === userID);
                          const commonProps = {
                            member,
                            filter: true,
                            toggleRow,
                            selectedMembers: selectedRows,
                            rowFilter,
                          };

                          return (
                            <>
                              { type == "UsersNew" ? (
                                <MemberDropdownNew
                                  {...commonProps}
                                  type={isUser ? "user" : ""}
                                  classNameAddition={isUser ? '-user-filter' : '-filter'}
                                  isUserAdminComponent={true}
                                />
                              ) : (
                                <MemberDropdown
                                  {...commonProps}
                                  type={isUser ? "user" : ""}
                                  classNameAddition={isUser ? '-user-filter' : '-filter'}
                                />
                              )}
                              <Dropdown.Divider style={{ width: "478px" }} />
                            </>
                          );
                        })}
                    </div>
                  </>
                ) : (
                  //DEFAULT DROPDOWN
                  <div className="filter-panel-dropdown-default-container">
                    <Dropdown.Divider style={{ width: "478px" }} />
                    <ToggleAll
                      type={allTitle}
                      toggleAllRows={toggleRow}
                      payload={payload}
                      rows={selectedRows}
                      rowFilter={rowFilter}
                    />
                    <Dropdown.Divider style={{ width: "478px" }} />
                    { rowFilter &&
                      rowFilter.map((row) => (
                        <>
                          <FilterDefaultDropdown
                            row={row}
                            nameParam={nameParam}
                            selectedRows={selectedRows}
                            toggleRow={toggleRow}
                            rowFilter={rowFilter}
                            idParam={idParam}
                          ></FilterDefaultDropdown>
                        </>
                      ))}
                  </div>
                )
              }
              {
                //MAKE THIS DIV A FLEXBOX
              }
              <div className={`filter-panel-button-container${nameClass}`}>
                <input
                  type={"button"}
                  variant="outline-primary"
                  onClick={(e) => {
                    clearFilter(e);
                  }}
                  className="filter-panel-clear-button"
                  value={"Clear Filter"}
                />
                <input
                  type={"button"}
                  onClick={() => {
                    saveFilter();
                  }}
                  value={"Apply Filter"}
                  className="filter-panel-apply-button"
                />
              </div>
            </Form>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

FiltersPanel.propTypes = {
  header: PropTypes.string,
  type: PropTypes.string.isRequired,
  close: PropTypes.func,
  selected: PropTypes.array,
  save: PropTypes.func,
  clear: PropTypes.func,
  updateSelected: PropTypes.func.isRequired,
  change: PropTypes.func,
  filterIcon: PropTypes.string,
  adminPayload: PropTypes.object,
  filterPayload: PropTypes.array
};

export default FiltersPanel;
